import { QueryFunctionContext } from '@tanstack/react-query';
import { DesignConductorService } from 'src/services/DesignConductorService';

export const QUERY_KEY = 'designContent';

export type DesignContentQueryKey = [
    typeof QUERY_KEY,
    string | undefined | false, // accessToken
    string, // productKey
    string, // productVersion
    string, // culture
    string, // designConceptId
    Record<string, string> | undefined, // selectedOptions
];

export const queryDesignContent = async ({
    queryKey,
}: QueryFunctionContext<DesignContentQueryKey>): Promise<any> => {
    const [, accessToken, productKey, productVersion, culture, designConceptId, selectedOptions] = queryKey;

    if (!accessToken) {
        throw new Error('No access token provided');
    }

    return DesignConductorService.getContent(
        productKey,
        productVersion,
        culture,
        designConceptId,
        selectedOptions,
    );
};
